// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeEntityList_category__vyzUF {
  margin-bottom: 30px;
}
.HomeEntityList_category__vyzUF .HomeEntityList_title__vRDep {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.HomeEntityList_category__vyzUF .HomeEntityList_title__vRDep .HomeEntityList_title-name__mWety {
  font-size: 24px;
  font-weight: 600;
}
.HomeEntityList_category__vyzUF .HomeEntityList_title__vRDep .HomeEntityList_browse__ZIgSO {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--explore-color);
  font-weight: 600;
  margin-left: 20px;
}
.HomeEntityList_category__vyzUF .HomeEntityList_title__vRDep .HomeEntityList_browse__ZIgSO svg {
  margin-left: 5px;
}
.HomeEntityList_category__vyzUF .HomeEntityList_title__vRDep .HomeEntityList_browse__ZIgSO p {
  color: var(--explore-color);
}
.HomeEntityList_category__vyzUF .HomeEntityList_show-more__TDukD {
  display: none;
}
@media only screen and (max-width: 480px) {
  .HomeEntityList_category__vyzUF .HomeEntityList_title__vRDep .HomeEntityList_title-name__mWety {
    font-size: 18px;
    font-weight: 600;
  }
  .HomeEntityList_category__vyzUF .HomeEntityList_title__vRDep .HomeEntityList_browse__ZIgSO {
    font-size: 18px;
  }
  .HomeEntityList_category__vyzUF .HomeEntityList_show-more__TDukD {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
  }
  .HomeEntityList_category__vyzUF .HomeEntityList_show-more__TDukD p {
    font-size: 17px;
    margin-bottom: 10px !important;
  }
  .HomeEntityList_category__vyzUF .HomeEntityList_show-more__TDukD button {
    border: none;
    border-radius: 10px;
    background: black;
    color: white;
    width: 130px;
    height: 45px;
    font-weight: bold;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Home/Components/HomeEntityList/HomeEntityList.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAEJ;AADI;EACE,eAAA;EACA,gBAAA;AAGN;AADI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;AAGN;AAFM;EACE,gBAAA;AAIR;AAFM;EACE,2BAAA;AAIR;AAAE;EACE,aAAA;AAEJ;AAAE;EAEI;IACE,eAAA;IACA,gBAAA;EACN;EACI;IACE,eAAA;EACN;EAEE;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;EAAJ;EACI;IACE,eAAA;IACA,8BAAA;EACN;EACI;IACE,YAAA;IACA,mBAAA;IACA,iBAAA;IACA,YAAA;IACA,YAAA;IACA,YAAA;IACA,iBAAA;EACN;AACF","sourcesContent":[".category {\n  margin-bottom: 30px;\n  .title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px;\n    .title-name {\n      font-size: 24px;\n      font-weight: 600;\n    }\n    .browse {\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      color: var(--explore-color);\n      font-weight: 600;\n      margin-left: 20px;\n      svg {\n        margin-left: 5px;\n      }\n      p {\n        color: var(--explore-color);\n      }\n    }\n  }\n  .show-more {\n    display: none;\n  }\n  @media only screen and (max-width: 480px) {\n    .title {\n      .title-name {\n        font-size: 18px;\n        font-weight: 600;\n      }\n      .browse {\n        font-size: 18px;\n      }\n    }\n    .show-more {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      margin-top: 10px;\n      p {\n        font-size: 17px;\n        margin-bottom: 10px !important;\n      }\n      button {\n        border: none;\n        border-radius: 10px;\n        background: black;\n        color: white;\n        width: 130px;\n        height: 45px;\n        font-weight: bold;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"category": `HomeEntityList_category__vyzUF`,
	"title": `HomeEntityList_title__vRDep`,
	"title-name": `HomeEntityList_title-name__mWety`,
	"browse": `HomeEntityList_browse__ZIgSO`,
	"show-more": `HomeEntityList_show-more__TDukD`
};
export default ___CSS_LOADER_EXPORT___;
